/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'FACILITY_REQUIRES_PREGNANCY_TEST_BEFORE_OR_AT_HIRING',
              'FACILITY_REQUIRES_VIRGINITY_TEST_BEFORE_OR_AT_HIRING',
              'FACILITY_REQUIRES_WORKER_TO_PROVIDE_COMMITMENTS_VERBALLY_OR_IN_',
              'FACILITY_REQUIRES_THE_USE_OF_CONTRACEPTIVES_OR_OTHER_FORMS_OF_B',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_follow_any_of_the_following_practices_related_to_w: valueSchema,
  },
}
